/** 
 * Максимальное дополнительное отклонение 
 * 1–2° — едва заметное покачивание 
 * 3–5° — наиболее естественно 
 * 8–15° — сильный 3D-эффект
*/
const maxAngle = 12
/**
 * Коэффициент сглаживания / инерция
 * каждый кадр элемент проходит 8% расстояния до целевого положения
 * чем меньше число, тем более "тяжёлым" кажется объект
 * 0.03	очень тяжёлый объект 
 * 0.05	плавный 
 * 0.08	хороший универсальный вариант 
 * 0.12	быстрый 
 * 0.2	почти без инерции
 */
const lerp = 0.08

/**
 * 
 * 
 */
export class EffectTilt {
  
  constructor(element: HTMLElement) {
    const baseRotation = {
      x: 4,
      y: -45,
      z: -2
    }

    const target = {
      x: 0,
      y: 0
    }

    const current = {
      x: 0,
      y: 0
    }

    document.addEventListener('mousemove', e => {
      target.x = (e.clientX - window.innerWidth / 2) / (window.innerWidth / 2)
      target.y = (e.clientY - window.innerHeight / 2) / (window.innerHeight / 2)

      target.x *= maxAngle
      target.y *= maxAngle
    })

    function animate() {
      current.x += (target.x - current.x) * lerp
      current.y += (target.y - current.y) * lerp

      element.style.transform = `
        perspective(800px)
        rotateY(${baseRotation.y + current.x}deg)
        rotateX(${baseRotation.x - current.y}deg)
        rotateZ(${baseRotation.z}deg)
      `

      requestAnimationFrame(animate)
    }

    animate()
  }
}
